









import {Component, Prop, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 4.2.1 Switched to inline block.
 * @changelog 4.16.0 Add option to open in a new tab, and update visuals to match on Article.
 * @changelog 6.5.5 Fixed the cursor issue
 */
@Component
export default class JdsLink extends Vue {
    @Prop() to!: Location
    @Prop() href!: string
    @Prop({type: Boolean, default: false}) newTab!: boolean

    get linkProps() {
        const props: Record<string, any> = {};

        if (this.to) {
            props.to = this.to;
        } else {
            props.href = this.to;
        }

        return props;
    }
}
